import { Insurer, PackageItemLimitType } from '../../enums'

// export interface OfferPackageAvailableAddon {
//     limit?: number
//     packageItemVariantId?: number
//     packageItemId?: number
//     riskId: number
//     riskName: string
//     included: boolean
//     addable: boolean
//     limitType?: PackageItemLimitType
//     description?: string
// }

export interface AdditionBase {
    offerPartId?: number
    packageItemId?: number
    riskId?: number
    insurer?: Insurer
    limit?: string
    variantId?: number | null
    key?: string
    value?: any
}

export interface AdditionBicycle extends AdditionBase {
    color?: string
    type?: string
    bikeType: keyof typeof BikeKinds
    identification?: string
    brand?: string
    description?: string
    version?: string
}

export enum BikeKinds {
    Bike = 'Kolo',
    ElectricBike = 'Elektrokolo',
    Scooter = 'Koloběžka',
    ElectricScooter = 'Elektrokoloběžka',
    BikeTrailer = 'Připojný vozík na kolo'
}

export interface AdditionPet extends AdditionBase {
    type: keyof typeof PetKinds
    age?: number | null
    chipId?: string
    name?: string
    race?: string
}

export enum PetKinds {
    Dog = "Pes",
    Cat = "Kočka"
}
export interface AdditionMedical extends AdditionBase {
    type?: string
    description?: string
}

export interface AdditionCycleAssistance extends AdditionBase {
    description: string
}

export interface AdditionIntLimitBase extends AdditionBase {
    key: string
}

export interface AdditionConstructionAssembly extends AdditionIntLimitBase {
    duration: DurationKinds
}

export interface AdditionSportEquipment extends AdditionBase {
    description: string
}

export interface AdditionVehicle extends AdditionBase {
    registrationMark: string
}

export enum DurationKinds {
    OneYear = "1 rok",
    TwoYears = "2 roky",
    ThreeYears = "3 roky"
}

export interface AdditionMusicalInstrument extends AdditionBase {
    description: string
}

export interface OfferPropertyAddition {
    bicycles: AdditionBicycle[]
    pets: AdditionPet[]
    medicals: AdditionMedical[]
    cycleAssistance: AdditionCycleAssistance[]
    constructionAssemblies: AdditionConstructionAssembly[]
    musicalInstruments: AdditionMusicalInstrument[]
}

export interface OfferTravelAddition {
    sportEquipments: AdditionSportEquipment[]
    vehicles: AdditionVehicle[]
}